// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__kLOO-","col":"Table_col__l6SHK","fulfillmentStatus":"Table_fulfillmentStatus__2ncmi","emailCol":"Table_emailCol__2tZEb"};